import { UserPermissions } from "../../auth/userContextProvider/UserContextProvider.types";

// Whether the user may open the edit stepper at all: any one step they can read is enough.
export function hasAccessToProcessingActivitySteps(permissions: UserPermissions) {
    return (
        (permissions.processingActivityAssociationPermissions?.permissions.read &&
            permissions.processingActivityAssociationPermissions.hasAnySubPermissionAccess) ||
        permissions.processingActivityMasterDataPermissions?.permissions.read ||
        permissions.processingActivityDataSubjectPermissions?.permissions.read ||
        permissions.processingActivitySystemPermissions?.permissions.read ||
        permissions.processingActivityLegalBasesPermissions?.permissions.read ||
        permissions.processingActivityDataCategoryPermissions?.permissions.read ||
        permissions.processingActivityDataProcessorsPermissions?.permissions.read ||
        permissions.processingActivitySourcesPermissions?.permissions.read ||
        permissions.processingActivityDisclosuresPermissions?.permissions.read ||
        permissions.processingActivityDataControllersPermissions?.permissions.read
    );
}
